import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Archive';

export const getRankings = async () => {
    const result = await request.get(`${baseUrl}/GetAll`);

    return result;
}

export const getRegNums = async (id, schoolId) => {
    const result = await request.get(`${baseUrl}/GetAllRegNumbers/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}